<template>
  <div id="contenedor-contrato-catalogo-favoritos">
    <template v-if="getProgramaDeObra.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info">
              Aún no se ha resgitrado un programa de obra.
            </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <v-card
      v-else
      flat>
      <v-card-text>
        <v-row
          align="center">
          <date-picker
            v-model="AlaFecha"
            cols="6"
            label="Fecha"
            md="3">
          </date-picker>
          <v-spacer></v-spacer>
          <v-col
            cols="6"
            md="3"
            class="text-right">
            <v-tooltip top bottom color="verde2"
            >
            <template v-slot:activator="{ on, attrs }">
              <custom-button
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                label=""
                iconText="fa-file-pdf"
                tipo="agregar"
                @click="preGenerarPdf"
              >
              </custom-button>
            </template>
            <span>Generar Ficha</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <div>
          <v-divider></v-divider>
        </div>
        <v-row
          justify="space-between">
          <v-col
            cols="12"
            md="7">
            <h3>Actividades principales</h3>
            <div>
              <v-alert
                v-if="getCatalogoConceptosAvancesAlaFecha.length <= 0"
                class="mt-3"
                type="warning">
                Esta fecha no tiene avances fisícos registrados, por favor seleccionar otra fecha.
              </v-alert>
            </div>
            <v-list>
              <template
                v-for="concepto in getContratoCatalogoFavoritos">
                <template>
                  <v-list-item
                    :key="concepto.id">
                    <v-list-item-action>
                      <v-chip
                        outlined>
                        {{ concepto.orden }}
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-medium">
                        {{ concepto.nombreCorto }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-progress-linear
                          :value="concepto.porcentajeAvance"
                          color="light-blue"
                          height="25">
                        </v-progress-linear>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip
                        :color="concepto.porcentajeAvance > 0 ? 'success' : ''"
                        :disabled="concepto.porcentajeAvance <= 0">
                        {{ concepto.porcentajeAvance }}%
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    :key="`divider-${concepto.id}`">
                  </v-divider>
                </template>
              </template>
            </v-list>
          </v-col>
          <v-col
            cols="12"
            md="4">
            <div id="contenedor-avance-fisco-financiero">
              <h3>Avances</h3>
              <v-row
                justify="center"
                align="center">
                <v-col
                  cols="auto">
                  <v-card
                    class="azul1"
                    flat
                    width="150">
                    <v-card-title>
                      Fisíco
                    </v-card-title>
                    <v-card-text
                      class="text-center">
                      <span class="text-h4">
                        {{ getPorcentajeAvanceFisicoAlaFecha }}%
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="auto">
                  <v-card
                    class="verde1"
                    flat
                    width="150">
                    <v-card-title>
                      Financiero
                    </v-card-title>
                    <v-card-text
                      class="text-center">
                      <span class="text-h4">
                        {{ getPorcentajeFinanciero }}%
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div>
              <line-chart
                :chart-data="dataSet"
                :options="optionsGrafica">
              </line-chart>
            </div>
            <v-divider
              class="my-3">
            </v-divider>
            <div id="contenedor-imagen-pricipal">
              <h3 class="mb-3">
                Seleccionar foto panoramica y croquis
              </h3>
              <v-card
                class="pa-2">
                <v-row
                  class="fill-height">
                  <v-col
                    cols="12"
                    class="seleccionar-imgen mb-2"
                    style="min-height: 200px;"
                    @click="seleccionadorDeImagenes('panoramica')">
                    <v-row
                      v-if="!imagenSeleccionada"
                      justify="center"
                      align="center"
                      class="fill-height ma-0">
                      <h4>
                        Seleccionar imagen panoramica
                      </h4>
                    </v-row>
                    <v-img
                      v-if="imagenSeleccionada"
                      :aspect-ratio="16/9"
                      :src="imagenSeleccionada">
                    </v-img>
                  </v-col>
                  <v-col
                    cols="12"
                    class="seleccionar-imgen"
                    style="min-height: 200px;"
                    @click="seleccionadorDeImagenes('')">
                    <v-row
                      v-if="!imagenOtraImagen"
                      justify="center"
                      align="center"
                      class="fill-height ma-0">
                      <h4>
                        Seleccionar imagen croquis
                      </h4>
                    </v-row>
                    <v-img
                      v-if="imagenOtraImagen"
                      :aspect-ratio="16/9"
                      :src="imagenOtraImagen">
                    </v-img>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="mostrarSeleccionarImagen"
      width="500">
      <v-card>
        <v-card-title>
          Seleccionar imagen
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarSeleccionarImagen = !mostrarSeleccionarImagen">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <template
            v-for="reporte in getActividadTipoAlbum">
            <template>
              <h4 :key="`titulo-${reporte.id}`">
                {{ reporte.frente.descripcion }}
              </h4>
              <v-row
                :key="`imagenes-${reporte.id}`">
                <template
                  v-for="imagen in reporte.imagenes">
                  <template>
                    <v-col
                      cols="auto"
                      :key="imagen">
                      <v-img
                        width="100"
                        :aspect-ratio="16/9"
                        :src="imagen"
                        style="cursor: pointer;"
                        @click="seleccionarImagen(imagen)">
                      </v-img>
                    </v-col>
                  </template>
                </template>
              </v-row>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mostrarPreGenerarPdf"
      width="450">
      <v-card>
        <v-card-title>
          Desea agregar una nota
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarPreGenerarPdf = !mostrarPreGenerarPdf">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
            v-model="nota"
            label="Nota">
          </custom-text-area>
          <v-tooltip bottom color="verde2" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="secondary--text"
                :loading="generandoPdfCatalogoFavoritos"
                @click="generarPdfCatalogoFavoritos"
                block
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="blue darken-1">
                    mdi-cloud-download
                </v-icon>
              </v-btn>
            </template>
            <span style="color:primary;">Descargar Pdf</span>
          </v-tooltip>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_CATALOGO_FAVORITOS from '@/graphql/querys/administracion/contratos/contrato/catalogofavoritos/contratoCatalogoFavoritos.gql';
import CONTRATO_ACTIVIDADES from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividades.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/contrato/avanceReal/contratoCatalogoConceptos.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import CONTRATO_PROGRAMAS_OBRAS from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import LineChart from '@/components/charts/LineChart';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixPdfFichaCatalogoFavoritos from './mixPdfFichaCatalogoFavoritos';

export default {
  name: 'DefaultContratoCatalogoFavoritos',
  components: {
    DatePicker,
    CustomTextArea,
    CustomButton,
    LineChart,
  },
  data() {
    return {
      mostrarPreGenerarPdf: false,
      mostrarSeleccionarImagen: false,
      seleccionarTipoImagen: '',
      nota: '',
      AlaFecha: new Date().toISOString().substr(0, 10),
      imagenSeleccionada: null,
      imagenOtraImagen: null,
      idContrato: this.$route.params.idContrato,
      generandoPdfCatalogoFavoritos: false,
      optionsGrafica: {
        responsive: true,
        maintainAspectRatio: false,
        plugin: {
          datalabels:
          {
            formatter: (value) => `1-${value}`,
            color: '#acf',
          },
        },
        legend: {
          position: 'bottom',
        },
      },
    };
  },
  mixins: [mixAvanceProgramado, mixPdfFichaCatalogoFavoritos],
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoFavoritos: {
      query: CONTRATO_CATALOGO_FAVORITOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoActividades: {
      query: CONTRATO_ACTIVIDADES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  mounted() {
    this.$apollo.queries.contratoCatalogoConceptos.refetch({
      idContrato: this.$route.params.idContrato,
    });

    this.$apollo.queries.contratoCatalogoFavoritos.refetch({
      idContrato: this.$route.params.idContrato,
    });
  },
  methods: {
    seleccionadorDeImagenes(tipo) {
      this.seleccionarTipoImagen = tipo;
      this.mostrarSeleccionarImagen = true;
    },
    seleccionarImagen(imagen) {
      if (this.seleccionarTipoImagen === 'panoramica') {
        this.imagenSeleccionada = imagen;
      } else {
        this.imagenOtraImagen = imagen;
      }

      this.mostrarSeleccionarImagen = false;
    },
    preGenerarPdf() {
      this.mostrarPreGenerarPdf = true;
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getProgramaDeObra() {
      if (!this.contratoProgramasObra) return [];
      if (this.contratoProgramasObra.length === 0) return [];
      const { programa } = this.contratoProgramasObra[0];
      if (!programa) return [];
      return programa
        .map((prog) => {
          const importeContratado = this.getImporteContratado;
          const fecha = new Date(`${prog.fechaTermino}T00:00:00Z`);
          const programaAcumulado = programa
            .filter(({ fechaTermino }) => new Date(`${fechaTermino}T00:00:00Z`) <= fecha);
          const importeProgramadoAcumulado = this.$ObjSumar(programaAcumulado, 'monto');
          const porcentaje = this.$numberRound(
            (importeProgramadoAcumulado / importeContratado)
            * 100,
          );

          return {
            ...prog,
            fecha,
            importeProgramadoAcumulado,
            porcentaje,
          };
        })
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getImporteContratado() {
      if (!this.contrato) return 0;
      return (this.contrato.importe + (this.contrato.modificado.importe));
    },
    importeDelContrato() {
      return this.getImporteContratado;
    },
    getContratoCatalogoFavoritos() {
      if (!this.contratoCatalogoFavoritos) return [];
      return this.contratoCatalogoFavoritos
        .slice()
        .map((favorito) => {
          const { estimado, avancesReales, cantidad } = favorito.concepto;

          const estimacionesFiltradas = estimado
            .filter(({ estimacion }) => new Date(`${estimacion.fechaAl}T00:00:00Z`) <= new Date(`${this.AlaFecha}T00:00:00Z`));

          const avancesRealesFiltradas = avancesReales
            .filter(({ fecha }) => new Date(`${fecha}T00:00:00Z`) <= new Date(`${this.AlaFecha}T00:00:00Z`));

          const cantidadEstimado = this.$ObjSumar(estimacionesFiltradas, 'cantidad');
          const cantidadAvance = this.$ObjSumar(avancesRealesFiltradas, 'cantidad');

          const total = (cantidadEstimado + cantidadAvance);

          const porcentajeAvance = Math.ceil(((total / cantidad) * 100));

          return {
            ...favorito,
            porcentajeAvance: porcentajeAvance > 100 ? 100 : porcentajeAvance,
          };
        })
        .sort((a, b) => a.orden - b.orden);
    },
    getContratoActividades() {
      if (!this.contratoActividades) return [];
      return this.contratoActividades;
    },
    getActividadTipoAlbum() {
      return this.getContratoActividades
        .filter(({ tipo }) => tipo === 3)
        .filter(({ fecha }) => new Date(`${fecha}T00:00:00Z`) <= new Date(`${this.AlaFecha}T00:00:00Z`))
        .map((actividad) => ({
          ...actividad,
          imagenes: actividad.imagenes.map((img) => `${this.$urlFileServer}/${img}`),
        }))
        .sort((a, b) => new Date(`${b.fecha}T00:00:00Z`) - new Date(`${a.fecha}T00:00:00Z`));
    },
    getUltimoReporteActividad() {
      if (this.getActividadTipoAlbum.length <= 0) return null;
      return this.getActividadTipoAlbum[0];
    },
    getRepoortesExeptoElUltimo() {
      if (!this.getUltimoReporteActividad) return this.getActividadTipoAlbum;
      return this.getActividadTipoAlbum
        .filter(({ id }) => id !== this.getUltimoReporteActividad.id);
    },
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones;
    },
    getImporteEstimadoAlaFecha() {
      const estimaciones = this.getEstimaciones
        .slice()
        .filter(({ fechaAl }) => new Date(`${fechaAl}T00:00:00Z`) <= new Date(`${this.AlaFecha}T00:00:00Z`));
      return this.$ObjSumar(estimaciones, 'importeEstimado');
    },
    getPorcentajeFinanciero() {
      return this.$numberRound(((this.getImporteEstimadoAlaFecha
      / this.getImporteContratado) * 100));
    },
    getCatalogoConceptosAvances() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos;
    },
    getCatalogoConceptosAvancesAlaFecha() {
      if (!this.contratoCatalogoFavoritos) return [];
      return this.contratoCatalogoFavoritos
        .slice()
        .map(({ concepto }) => {
          const { avancesReales } = concepto;
          const avancesRealesCopy = [...avancesReales]
            .filter(({ fecha }) => new Date(`${fecha}T00:00:00Z`) <= new Date(`${this.AlaFecha}T00:00:00Z`))
            .sort((a, b) => new Date(`${b.fecha}T00:00:00Z`) - new Date(`${a.fecha}T00:00:00Z`));

          if (!avancesRealesCopy[0]) {
            return [];
          }

          return {
            ...avancesRealesCopy[0],
            fechaFormat: new Date(`${avancesRealesCopy[0].fecha}T00:00:00Z`),
          };
        })
        .flat();
    },
    getImporteCatalogoConceptosAvancesAlaFecha() {
      return this.$ObjSumar(this.getCatalogoConceptosAvancesAlaFecha, 'importe');
    },
    getPorcentajeAvanceFisicoAlaFecha() {
      const importe = (this.getImporteCatalogoConceptosAvancesAlaFecha
      + this.getImporteEstimadoAlaFecha);

      const porcentaje = this.$numberRound(((importe
      / this.getImporteContratado) * 100));

      return porcentaje > 100 ? 100 : porcentaje;
    },
    getGraficaEstimacionesData() {
      const AlaFecha = new Date(`${this.AlaFecha}T00:00:00Z`);

      return [...this.getEstimaciones].map(({ fechaDel, fechaAl, importeEstimado }) => {
        const importeContratado = this.getImporteContratado;
        const fecha = new Date(`${fechaAl}T00:00:00Z`);
        const estimacionesAcumuladas = this.getEstimaciones
          .filter((estimacion) => new Date(`${estimacion.fechaAl}T00:00:00Z`) <= fecha);
        const importeEstimadoAcumulado = this.$ObjSumar(estimacionesAcumuladas, 'importeEstimado');
        const porcentaje = this.$numberRound(
          (importeEstimadoAcumulado / importeContratado)
            * 100,
        );
        return {
          fecha,
          fechaDel,
          fechaAl,
          porcentaje,
          importeEstimadoAcumulado,
          importeEstimado,
        };
      })
        .filter(({ fecha }) => new Date(fecha) <= AlaFecha)
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getGraficaFechasEstimaciones() {
      const AlaFecha = new Date(`${this.AlaFecha}T00:00:00Z`);

      return [...this.getGraficaEstimacionesData]
        .filter(({ fecha }) => new Date(fecha) <= AlaFecha)
        .map(({ fecha, fechaAl }) => ({
          fecha, fechaAl,
        }))
        .sort((a, b) => new Date(a) - new Date(b));
    },
    getGraficaFechasAvanceFisico() {
      // Fechas de la estimaciones
      const estimacionesFechas = [...this.getGraficaFechasEstimaciones];
      // get el ultimo registro
      const ultimaFechaEstiamcion = estimacionesFechas.slice(-1)[0]?.fecha || null;

      const fechasAvancesFisicos = [...this.getCatalogoConceptosAvancesAlaFecha]
        .filter(({ fechaFormat }) => {
          if (!ultimaFechaEstiamcion) return true;

          return new Date(fechaFormat) > new Date(ultimaFechaEstiamcion);
        })
        .map(({ fecha, fechaFormat }) => ({
          fecha,
          fechaFormat,
        }))
        .sort((a, b) => new Date(b.fechaFormat) - new Date(a.fechaFormat));

      // Regresar la ultima fecha del avance
      if (!fechasAvancesFisicos[0]) {
        return [];
      }
      return [fechasAvancesFisicos[0]];
    },
    getGraficaFechasProgramado() {
      // Fechas de la estimaciones
      const estimacionesFechas = [...this.getGraficaFechasEstimaciones];
      // get el ultimo registro
      const ultimaFechaEstiamcion = estimacionesFechas.slice(-1)[0]?.fecha || null;
      // Fechas de avance
      const avancesFechas = [...this.getGraficaFechasAvanceFisico];
      // set Ultima fecha del avance fisico
      const ultimaFechaAvanceFisico = avancesFechas[0]?.fechaFormat || null;

      return [...this.getProgramaDeObra]
        .filter(({ fecha }) => {
          if (ultimaFechaAvanceFisico) {
            return new Date(fecha) > new Date(ultimaFechaAvanceFisico);
          }
          if (ultimaFechaEstiamcion) {
            return new Date(fecha) > new Date(ultimaFechaEstiamcion);
          }

          return true;
        })
        .map(({ fecha, fechaTermino }) => ({
          fecha,
          fechaTermino,
        }))
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getGraficaEjeX() {
      const fechas = [
        ...this.getGraficaFechasEstimaciones.map(({ fechaAl }) => fechaAl),
        ...this.getGraficaFechasAvanceFisico.map(({ fecha }) => fecha),
        ...this.getGraficaFechasProgramado.map(({ fechaTermino }) => fechaTermino),
      ].sort((a, b) => new Date(a) - new Date(b));

      // Selecccionar primera fecha
      const [primeraFecha] = fechas;

      // Filtrar fechas del programado
      const fechasProgramado = [...this.getProgramaDeObra]
        .filter(({ fecha }) => new Date(fecha) < new Date(primeraFecha));
      return [
        ...fechasProgramado.map(({ fechaTermino }) => fechaTermino),
        ...fechas,
      ].sort((a, b) => new Date(a) - new Date(b));
    },
    getGraficaProgramadoData() {
      if (this.getGraficaEjeX.length <= 0) return [];

      const fechas = this.getGraficaEjeX;
      const programado = [];

      fechas.forEach((fecha) => {
        // Buscar avance programado a la fecha
        const getAvance = this.getProgramaDeObra
          .find((avance) => avance.fechaTermino === fecha);
        // Comprobar si no existe un registro
        if (!getAvance) {
          // Si no existe, entonces calculamos el programado a la fecha
          programado.push(this.mixCalcularPrograma(fecha));
        } else {
          // Si no se agrega el avance
          programado.push(getAvance);
        }
      });

      // se regresa los programado
      return programado;
    },
    getGraficaAvanceFisicoData() {
      const importeContratado = this.getImporteContratado;

      // Fechas ordenadas menor a mayor
      const fechasOrdenadasMenorMayor = [
        ...this.getGraficaFechasEstimaciones.map(({ fecha }) => fecha),
        ...this.getGraficaFechasAvanceFisico.map(({ fechaFormat }) => fechaFormat),
      ]
        .sort((a, b) => new Date(a) - new Date(b));

      // Selecccionar primera fecha
      const [primeraFecha] = fechasOrdenadasMenorMayor;

      // Filtrar fechas del programado
      const fechasProgramado = [...this.getProgramaDeObra]
        .filter(({ fecha }) => new Date(fecha) < new Date(primeraFecha));

      // Todas las fechas
      const fechas = [
        ...fechasProgramado.map(({ fecha }) => fecha),
        ...this.getGraficaFechasEstimaciones.map(({ fecha }) => fecha),
        ...this.getGraficaFechasAvanceFisico.map(({ fechaFormat }) => fechaFormat),
      ]
        .sort((a, b) => new Date(a) - new Date(b));

      // Avances fisicos
      const avanceFisico = [];

      fechas.forEach((fecha) => {
        // Filtrar los avances fisicos a la fecha
        const avancesFisicosAlaFecha = [...this.getCatalogoConceptosAvancesAlaFecha]
          .filter(({ fechaFormat }) => new Date(fechaFormat) <= new Date(fecha));
          // Sumar el importe de los avances encontrados
        const importeAvanceFisico = this.$ObjSumar(avancesFisicosAlaFecha, 'importe');
        // Filtrar estimaciones a la fecha
        const estimaciones = [...this.getGraficaEstimacionesData]
          .filter((est) => new Date(est.fecha) <= new Date(fecha));
          // Importe de la suma de las estimaciones
        const importeEstimado = this.$ObjSumar(estimaciones, 'importeEstimado');

        // Total de avance fisico (fisico + estimado)
        const totalAvance = this.$numberRound((importeAvanceFisico + importeEstimado));

        // Porcentaje de avance fisico real
        const porcentaje = this.$numberRound(((totalAvance / importeContratado) * 100));

        // Agregar el avance real al array
        avanceFisico.push({
          importe: totalAvance,
          porcentaje,
        });
      });

      // Regresar los avances fisicos
      return avanceFisico;
    },
    dataSet() {
      const fechas = this.getGraficaEjeX.map((fecha) => new Date(`${fecha}T00:00:00`).toLocaleDateString());
      return {
        labels: ['', ...fechas],
        datasets: [
          {
            label: 'PROGRAMADO',
            fill: false,
            data: [0, ...this.getGraficaProgramadoData.map(({ porcentaje }) => porcentaje)],
            borderColor: '#FA8B00',
            tension: 0.1,
            pointRadius: 4,
          },
          {
            label: 'FISICO',
            fill: false,
            data: [0, ...this.getGraficaAvanceFisicoData.map(({ porcentaje }) => porcentaje)],
            borderColor: '#1E88E5',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 4,
          },
          {
            label: 'FINANCIERO',
            fill: false,
            data: [0, ...this.getGraficaEstimacionesData
              .map(({ porcentaje }) => porcentaje)],
            borderColor: '#43A047',
            tension: 0.1,
            pointStyle: 'rect',
            pointRadius: 8,

          },
        ],
      };
    },
  },
  watch: {
    getActividadTipoAlbum: {
      handler(actividades) {
        if (actividades.length <= 0) {
          this.imagenSeleccionada = null;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.seleccionar-imgen {
  border: 1px dashed #ccc;
  border-radius: 5px;
  cursor: pointer;
}
.seleccionar-imgen:hover {
  border-style: solid;
}
.imagen-seleccionada {
  border: 1px solid #ccc;
  box-sizing: border-box;
}
</style>
